import React, { useEffect } from "react";
import PhImage from "../common/PhImage";

export default function ProjectModal({ project, onClose }) {
  useEffect(() => {
    if (!project) return;

    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [project, onClose]);

  if (!project) return null;

  const stop = (e) => e.stopPropagation();
  const hasLive = project.live && project.live !== "none";

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-panel" onClick={stop}>
        <div className="modal-header">
          <div>
            <div className="modal-platform-label mono">
              {project.platformsLabel}
            </div>
            <h2 className="modal-title">{project.title}</h2>
          </div>
          <button className="modal-close" aria-label="Close" onClick={onClose}>
            ✕
          </button>
        </div>

        <PhImage className="modal-hero" ratio="16/9" src={project.image} alt={project.title} />

        <div className="modal-body">
          <div className="modal-actions">
            {hasLive && (
              <a
                className="lnk btn-modal-live mono"
                href={project.live}
                target="_blank"
                rel="noreferrer"
                onClick={stop}
              >
                Visit live ↗
              </a>
            )}
            <a
              className="lnk btn-modal-code mono"
              href={project.repo}
              target="_blank"
              rel="noreferrer"
              onClick={stop}
            >
              View code ↗
            </a>
          </div>

          <div className="modal-desc">
            {project.description.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>

          <div className="modal-subhead mono">STACK</div>
          <div className="modal-tags mono">
            {project.categories.map((cat) => (
              <span className="tag-pill lg" key={cat}>
                {cat}
              </span>
            ))}
          </div>

          <div className="modal-subhead mono">PLATFORMS</div>
          <div className="platform-list">
            {project.platforms.map((pf) => (
              <div className="platform-card" key={pf.platform_title}>
                <div className="platform-head">
                  <span className="platform-badge mono">
                    {pf.platform_name}
                  </span>
                  <span className="platform-title">{pf.platform_title}</span>
                </div>
                <p className="platform-desc">{pf.platform_desc}</p>
                <div className="platform-links mono">
                  {pf.platform_site && pf.platform_site !== "none" && (
                    <a
                      className="lnk project-link-live"
                      href={pf.platform_site}
                      target="_blank"
                      rel="noreferrer"
                      onClick={stop}
                    >
                      Live ↗
                    </a>
                  )}
                  <a
                    className="lnk project-link-code"
                    href={pf.platform_repo}
                    target="_blank"
                    rel="noreferrer"
                    onClick={stop}
                  >
                    Repository ↗
                  </a>
                </div>
              </div>
            ))}
          </div>

          {project.gallery.length > 0 && (
            <>
              <div className="modal-subhead mono">GALLERY</div>
              <div className="gallery-grid">
                {project.gallery.map((g, i) => (
                  <PhImage
                    key={i}
                    className="gallery-item"
                    ratio="16/10"
                    src={g.link}
                    alt=""
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
